import * as fetch from "../../common/fetch";

import { GroupGetUsersResponseType } from "../responses/groupResponseTypes";

import type {
  UserGetResponseType,
  UserGetAllResponseType,
  UserGetRolesResponseType,
  UserGetMyselfResponseType,
  UserGetPoliciesResponseType
} from "../responses/userResponseTypes";

import type {
  UserDeleteRequestType,
  UserCreateRequestType,
  UserUpdateRequest
} from "../requests/userRequestTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/users`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/users/${id}`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetResponseType;
  }
}

export async function getRoles(id) {
  const response = await fetch.get(`${url}/users/${id}/roles`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetRolesResponseType;
  }
}

export async function getGroups(id) {
  const response = await fetch.get(`${url}/users/${id}/groups`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetUsersResponseType;
  }
}

export async function getPolicies(id) {
  const response = await fetch.get(`${url}/users/${id}/policies`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetPoliciesResponseType;
  }
}

export async function createUser(body: UserCreateRequestType) {
  const response = await fetch.post(`${url}/users`, body);
  return response.ok;
}

export async function updateUser(id, body: UserUpdateRequest) {
  const response = await fetch.put(`${url}/users/${id}`, body);
  return response.ok;
}

export async function getMyself() {
  const response = await fetch.get(`${url}/users/myself`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetMyselfResponseType;
  }
}

export async function deleteUser(id, body: UserDeleteRequestType) {
  const response = await fetch.del(`${url}/users/${id}`, body);
  return response.ok;
}

export async function updateMyActivity() {
  const response = await fetch.put(`${url}/users/myself/activity`, {});
  return response.ok;
}
